import { FormControl } from '@angular/forms';

export class BioSicherheitPlanSchwein {
    bs_id: number;

    v1_1_datum: Date;
    v1_2_verantwortlich: string;
    v1_3_verantwortlich_adresse: string;
    v1_4_verantwortlich_telefon: string;
    v1_6_verantwortlich_email: string;
    v1_5_beihilfe_tsk: string;
    v1_7_steuer_optierend: number;
    v1_8_steuer_pauschal: number;
    beratungszeit_tierarzt_stunden: number;
    beratungszeit_berater_stunden: number;
    v1_9_berater_name: string;
    v1_10_berater_adresse: string;
    v1_11_berater_telefon: string;
    v1_12_berater_email: string;
    v1_13_standort_adresse: string;
    v1_14_anzahl_staelle: number;
    v1_15_stall_bezeichnungen: string;
    v1_16_anzahl_sauenplaetze: number;
    v1_17_anzahl_aufzuchtplaetze: number;
    v1_18_anzahl_mastplaetze: number;
    v1_19_mit_auslauf: number;
    v1_20_freiland: number;
    v1_21_stroh: number;
    v1_22_anlage: string;
    v1_23_aufstallung: string;

    v2_1_antwort: string;
    v2_1_unterlage: string;
    v2_2_antwort: string;
    v2_2_unterlage: string;
    v2_3_antwort: string;
    v2_3_unterlage: string;
    v2_4_antwort: string;
    v2_4_unterlage: string;
    v2_5_antwort: string;
    v2_5_unterlage: string;
    v2_6_antwort: string;
    v2_6_unterlage: string;
    v2_7_antwort: string;
    v2_7_unterlage: string;
    v2_8_antwort: string;
    v2_8_unterlage: string;
    v2_9_antwort: string;
    v2_9_unterlage: string;
    v2_10_handlungsbedarf: number;
    v2_10_antwort: string;
    v2_10_unterlage: string;
    v2_11_handlungsbedarf: number;
    v2_11_antwort: string;
    v2_11_unterlage: string;
    v2_12_handlungsbedarf: number;
    v2_12_antwort: string;
    v2_12_unterlage: string;
    v3_13_unterlage: string;
    v3_14_unterlage: string;
    v3_15_antwort: string;
    v3_15_unterlage: string;
    v3_16_antwort: string;
    v3_16_unterlage_ein_und_ausgaenge: number;
    v3_16_unterlage_leicht_erreichbare_stellen: number;
    v3_16_unterlage_sonstiges: string;
    v3_17_antwort: string;
    v3_17_unterlage: string;
    v3_18_antwort: string;
    v3_18_unterlage: string;
    v3_19_antwort: string;
    v3_19_unterlage_sonstiges: number;
    v3_19_unterlage_sonstiges_text: string;
    v3_19_unterlage_im_weissbereich: number;
    v3_19_unterlage_im_schwarzbereich: number;
    v3_20_antwort: string;
    v3_20_unterlage: string;
    v3_21_antwort: string;
    v3_21_unterlage: string;
    v3_22_antwort: string;
    v3_23_antwort: string;
    v3_22_unterlage: string;
    v3_23_unterlage: string;
    v3_24_antwort: string;
    v3_24_unterlage: string;
    v3_25_antwort: string;
    v3_26_antwort: string;
    v3_26_unterlage: string;
    v3_27_antwort: string;
    v3_27_unterlage: string;
    v3_28_antwort: string;
    v3_28_unterlage: string;
    v5_36_handlungsbedarf: number;
    v5_36_antwort: string;
    v5_36_unterlage: string;
    v5_37_handlungsbedarf: number;
    v5_37_antwort: string;
    v5_37_unterlage: string;
    v5_38_handlungsbedarf: number;
    v5_38_antwort: string;
    v5_38_unterlage: string;
    v5_39_handlungsbedarf: number;
    v5_39_antwort: string;
    v5_39_unterlage: string;
    v5_40_handlungsbedarf: number;
    v5_40_antwort: string;
    v5_40_unterlage: string;
    v5_41_handlungsbedarf: number;
    v5_41_antwort: string;
    v5_41_unterlage: string;
    v5_42_handlungsbedarf: number;
    v5_42_antwort: string;
    v5_42_unterlage: string;
    v5_43_vollstaendig: number;
    v5_43_restemast: number;
    v5_43_abteilweise: number;
    v5_43_antwort: string;
    v5_43_unterlage: string;
    v5_44_kein_zukauf: number;
    v5_44_eber: number;
    v5_44_jungsauen: number;
    v5_44_sonstige: number;
    v5_44_antwort: string;
    v5_44_unterlage: string;
    v5_45_antwort: string;
    v5_45_unterlage: string;
    v5_46_antwort: string;
    v5_46_unterlage: string;
    v5_47_antwort: string;
    v5_47_unterlage: string;
    v6_48_handlungsbedarf: number;
    v6_48_antwort: string;
    v6_48_unterlage: string;
    v6_49_handlungsbedarf: number;
    v6_49_antwort: string;
    v6_49_unterlage: string;
    v6_50_handlungsbedarf: number;
    v6_50_antwort: string;
    v6_50_unterlage: string;
    v6_51_handlungsbedarf: number;
    v6_51_antwort: string;
    v6_51_unterlage: string;
    v6_52_handlungsbedarf: number;
    v6_52_antwort: string;
    v6_52_unterlage: string;
    v6_53_handlungsbedarf: number;
    v6_53_antwort: string;
    v6_53_unterlage: string;
    v6_54_handlungsbedarf: number;
    v6_54_antwort: string;
    v6_54_unterlage: string;
    v7_55_handlungsbedarf: number;
    v7_55_antwort: string;
    v7_55_unterlage: string;
    v7_55_einfriedung: number;
    v7_55_tore: number;
    v7_55_beschilderung: number;
    v7_55_auslauf: number;
    v7_55_sonstiges: number;
    v7_56_handlungsbedarf: number;
    v7_56_antwort: string;
    v7_56_unterlage: string;
    v7_57_handlungsbedarf: number;
    v7_57_antwort: string;
    v7_57_unterlage: string;
    v7_58_handlungsbedarf: number;
    v7_58_antwort: string;
    v7_58_unterlage: string;
    v7_59_handlungsbedarf: number;
    v7_59_antwort: string;
    v7_59_unterlage: string;
    v8_60_antwort: string;
    v8_60_unterlage: string;
    v8_61_antwort: string;
    v8_61_unterlage: string;
    v8_62_antwort: string;
    v8_62_unterlage: string;
    v8_63_antwort: string;
    v8_63_unterlage: string;
    v8_64_antwort: string;
    v8_64_unterlage: string;
    v8_65_antwort: string;
    v8_65_unterlage: string;
    v8_66_unterlage: string;
    v8_66_antwort: string;
    v8_67_antwort: string;
    v8_67_unterlage: string;
    v8_68_antwort: string;
    v8_69_antwort: string;
    v8_68_unterlage: string;
    v8_69_unterlage: string;
    v8_70_antwort: string;
    v8_70_unterlage: string;
    v8_71_antwort: string;
    v8_71_unterlage: string;
    v8_72_antwort: string;
    v8_72_unterlage: string;
    v8_73_handlungsbedarf: number;
    v8_73_einfriedung: number;
    v8_73_geschlossen: number;
    v8_73_beschilderung: number;
    v8_73_auslauf: number;
    v8_73_sonstiges: number;
    v8_73_antwort: string;
    v8_73_unterlage: string;
    v8_74_handlungsbedarf: number;
    v8_74_antwort: string;
    v8_74_unterlage: string;
    v8_75_handlungsbedarf: number;
    v8_75_antwort: string;
    v8_75_unterlage: string;
    v8_76_handlungsbedarf: number;
    v8_76_antwort: string;
    v8_76_unterlage: string;
    v8_77_handlungsbedarf: number;
    v8_77_antwort: string;
    v8_77_unterlage: string;
    v8_78_handlungsbedarf: number;
    v8_78_antwort: string;
    v8_78_unterlage: string;
    v8_79_handlungsbedarf: number;
    v8_79_antwort: string;
    v8_79_unterlage: string;
    v8_80_handlungsbedarf: number;
    v8_80_antwort: string;
    v8_80_unterlage: string;
    v8_81_handlungsbedarf: number;
    v8_81_antwort: string;
    v8_81_unterlage: string;
    v8_82_handlungsbedarf: number;
    v8_82_antwort: string;
    v8_82_unterlage: string;
    v8_83_handlungsbedarf: number;
    v8_83_antwort: string;
    v8_83_unterlage: string;
    v8_84_handlungsbedarf: number;
    v8_84_antwort: string;
    v8_84_unterlage: string;
    v8_85_handlungsbedarf: number;
    v8_85_antwort: string;
    v8_85_unterlage: string;
    v8_86_handlungsbedarf: number;
    v8_86_antwort: string;
    v8_86_unterlage: string;
    v8_87_handlungsbedarf: number;
    v8_87_schleuse: number;
    v8_87_ort_schleuse: number;
    v8_87_antwort: string;
    v8_87_unterlage: string;
    v8_88_handlungsbedarf: number;
    v8_88_antwort: string;
    v8_88_unterlage: string;
    v8_89_handlungsbedarf: number;
    v8_89_antwort: string;
    v8_89_unterlage: string;
    v9_90_handlungsbedarf: number;
    v9_90_antwort: string;
    v9_90_unterlage: string;
    v9_91_handlungsbedarf: number;
    v9_91_antwort: string;
    v9_91_unterlage: string;
    v10_92_handlungsbedarf: number;
    v10_92_bestandsregister: number;
    v10_92_berechnung_verluste: number;
    v10_92_sauenplaner: number;
    v10_92_mastplaner: number;
    v10_92_nach_aufzeichnungen: number;
    v10_92_antwort: string;
    v10_92_unterlage: string;
    v10_93_handlungsbedarf: number;
    v10_93_mit_hilfe: number;
    v10_93_mindestens: number;
    v10_93_antwort: string;
    v10_93_unterlage: string;
    v10_94_handlungsbedarf: number;
    v10_94_antwort: string;
    v10_94_unterlage: string;
    v10_95_handlungsbedarf: number;
    v10_95_antwort: string;
    v10_95_unterlage: string;
    v10_96_handlungsbedarf: number;
    v10_96_antwort: string;
    v10_96_unterlage: string;
    v10_97_handlungsbedarf: number;
    v10_97_antwort: string;
    v10_97_unterlage: string;
    v10_98_handlungsbedarf: number;
    v10_98_antwort: string;
    v10_98_unterlage: string;
    v10_99_handlungsbedarf: number;
    v10_99_antwort: string;
    v10_99_unterlage: string;
    v11_100_handlungsbedarf: number;
    v11_100_antwort: string;
    v11_100_unterlage: string;
    v11_101_handlungsbedarf: number;
    v11_101_antwort: string;
    v11_101_unterlage: string;
    v11_102_handlungsbedarf: number;
    v11_102_antwort: string;
    v11_102_unterlage: string;
    v11_103_handlungsbedarf: number;
    v11_103_antwort: string;
    v11_103_unterlage: string;
    v11_104_handlungsbedarf: number;
    v11_104_antwort: string;
    v11_104_unterlage: string;
    v11_105_handlungsbedarf: number;
    v11_105_antwort: string;
    v11_105_unterlage: string;
    v11_106_handlungsbedarf: number;
    v11_106_antwort: string;
    v11_106_unterlage: string;
    v11_107_handlungsbedarf: number;
    v11_107_antwort: string;
    v11_107_unterlage: string;
    v11_108_handlungsbedarf: number;
    v11_108_antwort: string;
    v11_108_unterlage: string;
    v11_109_handlungsbedarf: number;
    v11_109_antwort: string;
    v11_109_unterlage: string;
    v12_110_handlungsbedarf: number;
    v11_100_mastbetrieb: number;
    v11_100_zusammenschluss: number;
    v11_100_ab_stall: number;
    v12_110_antwort: string;
    v12_110_unterlage: string;
    v12_111_handlungsbedarf: number;
    v12_111_antwort: string;
    v12_111_unterlage: string;
    v12_112_handlungsbedarf: number;
    v12_112_antwort: string;
    v12_112_unterlage: string;
    v12_113_handlungsbedarf: number;
    v12_113_antwort: string;
    v12_113_unterlage: string;
    v12_114_handlungsbedarf: number;
    v12_114_antwort: string;
    v12_114_unterlage: string;
    v13_115_handlungsbedarf: number;
    v13_115_antwort: string;
    v13_115_unterlage: string;
    v13_116_handlungsbedarf: number;
    v13_116_antwort: string;
    v13_116_unterlage: string;
    v13_117_handlungsbedarf: number;
    v13_117_antwort: string;
    v13_117_unterlage: string;
    v13_118_handlungsbedarf: number;
    v13_118_antwort: string;
    v13_118_unterlage: string;
    v13_119_handlungsbedarf: number;
    v13_119_antwort: string;
    v13_119_unterlage: string;
    v14_120_handlungsbedarf: number;
    v14_120_antwort: string;
    v14_120_unterlage: string;
    v14_121_handlungsbedarf: number;
    v14_121_antwort: string;
    v14_121_unterlage: string;
    v14_122_handlungsbedarf: number;
    v14_122_antwort: string;
    v14_122_unterlage: string;
    v123_zu_nr: string;
    v123_erledigt: number;
    v123_schwachstelle: string;
    v123_handlungsempfehlung: string;
    v123_unterlage: string;

    v124_zu_nr: string;
    v124_erledigt: number;
    v124_schwachstelle: string;
    v124_handlungsempfehlung: string;
    v124_unterlage: string;

    v125_zu_nr: string;
    v125_erledigt: number;
    v125_schwachstelle: string;
    v125_handlungsempfehlung: string;
    v125_unterlage: string;

    // Zusätzliche Handlungsempfehlungen (dynamisch)
    v126_zu_nr: string;
    v126_erledigt: number;
    v126_schwachstelle: string;
    v126_handlungsempfehlung: string;
    v126_unterlage: string;

    v127_zu_nr: string;
    v127_erledigt: number;
    v127_schwachstelle: string;
    v127_handlungsempfehlung: string;
    v127_unterlage: string;

    v128_zu_nr: string;
    v128_erledigt: number;
    v128_schwachstelle: string;
    v128_handlungsempfehlung: string;
    v128_unterlage: string;

    v129_zu_nr: string;
    v129_erledigt: number;
    v129_schwachstelle: string;
    v129_handlungsempfehlung: string;
    v129_unterlage: string;

    v130_zu_nr: string;
    v130_erledigt: number;
    v130_schwachstelle: string;
    v130_handlungsempfehlung: string;
    v130_unterlage: string;

    v131_zu_nr: string;
    v131_erledigt: number;
    v131_schwachstelle: string;
    v131_handlungsempfehlung: string;
    v131_unterlage: string;

    v132_zu_nr: string;
    v132_erledigt: number;
    v132_schwachstelle: string;
    v132_handlungsempfehlung: string;
    v132_unterlage: string;

    mandant_id: number;
    kunde_id: number;
    tierarzt_id: number;
    status_id: number;
    kuid: string;
    berater_kuid: string;
    unterschrift_kunde: number;
    reinigungen: BioSicherheitPlanSchweinReinigung[] = [];
    bs_files: BioSicherheitsPlanFile[] = [];
    geloescht: number;
    editiert: Date;
    editiert_von: number;
    erstellt: Date;
    erstellt_von: number;

    strasse_lieferung: string;
    plz_lieferung: string;
    ort_lieferung: string;
    strasse: string;
    plz: string;
    ort: string;
    tsk_nummer: string;
    vvvo: string;
    kunde: string;
    zusatz: string;
}

export class BioSicherheitPlanSchweinReinigung {
    bsr_id: number;
    bs_id: number;
    geloescht?: number;
    stall: string;
    v4_29_handlungsbedarf: number;
    v4_29_antwort: string;
    v4_29_unterlage: string;
    v4_30_handlungsbedarf: number;
    v4_30_antwort: string;
    v4_30_unterlage: string;
    v4_31_handlungsbedarf: number;
    v4_31_antwort: string;
    v4_31_unterlage: string;
    v4_32_handlungsbedarf: number;
    v4_32_antwort: string;
    v4_32_unterlage: string;
    v4_33_handlungsbedarf: number;
    v4_35_massnahmen: string;
    v4_33_antwort: string;
    v4_33_unterlage: string;
    v4_34_handlungsbedarf: number;
    v4_34_antwort: string;
    v4_34_unterlage: string;
    v4_35_handlungsbedarf: number;
    v4_35_antwort: string;
    v4_35_unterlage: string;
}

export class Reinigungseintrag {
    static CONTROL_LENGTH = 7;
    fc_stall: FormControl;
    bsr_id?: number;
    id: number;
    formControls: ReinigungFormControls[] = [];
    bs_id: number;
    geloescht?: number;
}

export class ReinigungFormControls {
    handlungsbedarf: FormControl;
    antwort: FormControl;
    unterlage: FormControl;
    massnahmen?: FormControl;
    fragenTexte = [
        'Welche Bauteile des Stalles werden bei jedem Durchgang mitgereinigt und desinfiziert? (Lüftung, Decken, Fütterung...)',
        'Welche Bauteile des Stalles... (zweite Zeile identisch oder verändert)',
        'Desinfektion: Mittel, Temperatur, Dosierung, Nacharbeiten…',
        'R+D der Ausrüstung: Farbzuordnung, Abstände…',
        'Gänge und Verkehrsflächen: Werden diese regelmäßig gereinigt?',
        'Überprüfung: Wie wird der Erfolg kontrolliert?',
        'Weitere Maßnahmen: …',
    ];

    getFragenText(index: number): string {
        return this.fragenTexte[index] || 'Text not found';
    }

    constructor(handlungsbedarf: number, antwort: string, unterlage: string, massnahmen?: string) {
        this.handlungsbedarf = new FormControl(!!handlungsbedarf);
        this.antwort = new FormControl(antwort);
        this.unterlage = new FormControl(unterlage);

        if (massnahmen !== undefined) {
            this.massnahmen = new FormControl(massnahmen);
        }
    }
}

export class BioSicherheitsPlanFile {
    bsd_id: number;
    bs_id: number;
    pdf_id: number;
    file: File;
    dateiname: string;
    sektion: string;
    isNew: boolean;
}

export class HandlungsempfehlungEintrag {
    static CONTROL_LENGTH = 5;
    zu_nr: FormControl;
    erledigt: FormControl;
    schwachstelle: FormControl;
    handlungsempfehlung: FormControl;
    unterlage: FormControl;
    id: number;
    bs_id: number;
    geloescht?: number;
    isNew?: boolean;
}
